<dx-toolbar [items]="toolbarItems"></dx-toolbar>
<div class="grid-container">
  <dx-data-grid
    #useCaseGrid
    [dataSource]="useCases$ | async"
    [columns]="columnsUseCases"
    keyExpr="id"
    [(selectedRowKeys)]="selectedRowKey"
    (onSelectionChanged)="onSelectionChanged($event)"
    [showBorders]="true"
    [filterRow]="{
      visible: true
    }"
    [allowColumnResizing]="true"
  >
    <dxo-editing [allowUpdating]="true" [useIcons]="true" mode="popup" newRowPosition="last"> </dxo-editing>
    <dxo-selection [allowSelectAll]="true" mode="multiple"></dxo-selection>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>

<dx-popup
  *ngIf="visible"
  title="Use case"
  [hideOnOutsideClick]="true"
  [height]="450"
  [visible]="true"
  [width]="600"
  (onHiding)="hidePopup()"
>
  <dxi-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="saveBtnOptions"
    [disabled]="useCaseFormGroup.pristine || !useCaseFormGroup.valid"
  >
  </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelBtnOptions"> </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="useCaseFormGroup">
      <dx-text-box
        name="name"
        formControlName="name"
        label="Name"
        labelMode="floating"
        stylingMode="outlined"
        [isValid]="nameControl.valid || !nameControl.touched"
        [validationError]="{ message: 'Name is mandatory!' }"
      ></dx-text-box>
      <dx-select-box
        name="process"
        formControlName="process"
        label="Process"
        labelMode="floating"
        [dataSource]="filteredProcesses()"
        displayExpr="name"
        [showClearButton]="true"
        [acceptCustomValue]="true"
        customItemCreateEvent="focusout"
        (onCustomItemCreating)="onCustomItemCreating($event)"
        [searchEnabled]="true"
        searchExpr="name"
        stylingMode="outlined"
        [isValid]="processControl.valid || !processControl.touched"
        [validationError]="{ message: 'Process is mandatory!' }"
      ></dx-select-box>
      <dx-select-box
        name="domain"
        formControlName="domain"
        label="Domain"
        labelMode="floating"
        [dataSource]="filteredDomain()"
        displayExpr="name"
        [showClearButton]="true"
        [acceptCustomValue]="true"
        customItemCreateEvent="focusout"
        (onCustomItemCreating)="onCustomItemCreating($event)"
        [searchEnabled]="true"
        searchExpr="name"
        stylingMode="outlined"
        [isValid]="domainControl.valid || !domainControl.touched"
        [validationError]="{ message: 'Domain is mandatory!' }"
      ></dx-select-box>
      <dx-select-box
        name="macrosector"
        formControlName="macrosector"
        label="Macrosector"
        labelMode="floating"
        [dataSource]="macrosectors()"
        displayExpr="name"
        [showClearButton]="true"
        [acceptCustomValue]="true"
        customItemCreateEvent="focusout"
        (onCustomItemCreating)="onCustomItemCreating($event)"
        [searchEnabled]="true"
        searchExpr="name"
        stylingMode="outlined"
        [isValid]="macrosectorControl.valid || !macrosectorControl.touched"
        [validationError]="{ message: 'Macrosector is mandatory!' }"
      ></dx-select-box>
    </form>
  </div>
</dx-popup>

<dx-popup
  *ngIf="visibleDelete"
  title="Deletion"
  [hideOnOutsideClick]="true"
  [height]="250"
  [visible]="true"
  [width]="300"
  (onHiding)="hideDeletePopup()"
>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="deleteBtnOptions"> </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelDeleteBtnOptions"> </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    Are you sure to delete <strong>{{ selectedUseCases.join(", ") }}</strong>
    ?
  </div>
</dx-popup>
